/*=========================================================================================
  File Name: AmisAPI.js
  Description: AMIS Convert API
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
import BaseAPI from './base/base-api';

class AmisAPI extends BaseAPI {
	constructor() {
		super();
	}
	urlName = 'ManagementAPI';
	controllerName = 'amis';
}

export default new AmisAPI();
